import Glide from '@glidejs/glide'

new Glide('.glide', {
	type: 'carousel',
	perView: 3,
	gap: 40,
	breakpoints: {
		660: {
			perView: 1
		}
	}
}).mount()